<template>
  <a-modal
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :footer="false"
    :width="960"
    class="map-dialog"
    @cancel="hide"
  >
    <h3 class="title">
      <p v-if="fieldtype === 'area'">
        {{ $t('message["214"]') }}：<span class="fs-blue"> {{ address }} </span>
      </p>
      <p v-else-if="fieldtype === 'ip'">
        {{ $t('message["1714"]') }}：<span class="fs-blue"> {{ ip }} {{ data.name }}</span>
      </p>
    </h3>
    <div
      v-if="timeZone !== undefined"
      class="info-box clearfix"
    >
      <p>{{ $t('message["1158"]') }}：UTC/GMT {{ timeZone > 0 ? '+' : '' }}{{ timeZone }}</p>
      <p>
        {{ $t('message["152"]') }}：<span v-if="time">{{ moment(time).format('YYYY-MM-DD HH:mm') }}</span> <span
          v-if="week"
          class="week"
        >{{ curDay }}</span>
      </p>
      <p>{{ $t('message["422"]') }}：{{ (data.area_code && data.area_code.country_code) || '—' }}</p>
      <p>{{ $t('message["210"]') }}：{{ (data.area_code && data.area_code.area_code) || '—' }}</p>
    </div>
    <div
      v-else
      class="info-box fs-gray"
    >
      {{ $t('message["626"]') }}
    </div>
    <Map
      v-if="visible && lat && lng"
      ref="basicMapbox"
      map-width="100%"
      map-height="324px"
      :lng="lng"
      :lat="lat"
      :country-code="countryCode"
      :level="level"
      :fieldkey="fieldkey"
    />
  </a-modal>
</template>
<script>
import moment from 'moment'
import { getInquiryGeo } from '@/services/inqueryServices'
// import Map from './TxMap'
import { getLang } from '@/lib/storage'

import Map from './Leaflet'

export default {
  components: {
    Map
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lastCode: {
      type: String,
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    ip: {
      type: String,
      default: ''
    },
    fieldtype: {
      type: String,
      default: ''
    },
    fieldkey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      data: {},
      lat: '',
      lng: '',
      timeZone: '',
      time: '',
      countryCode: '',
      level: ''
    }
  },
  computed: {
    week () {
      let weeks = this.$t('message["945"]').split(',') // ['日', '一', '二', '三', '四', '五', '六']
      let w = moment(this.time).day()
      return this.time ? weeks[w] : ''
    },
    daySelected () {
      return {
        'day': 'Sunday',
        'one': 'Monday',
        'two': 'Tuesday',
        'three': 'Wednesday',
        'four': 'Thursday',
        'five': 'Friday',
        'six': 'Saturday'
      }
    },
    curDay () {
      const lang = this.getLang()
      return lang === 'en' ? this.daySelected[this.week] : '星期' + this.week
    }
  },
  async created () {
    await this.getCenter()
  },
  methods: {
    getLang,
    moment,
    hide () {
      this.$emit('update:visible', false)
    },
    async getCenter () {
      let params = {
        fieldtype: this.fieldtype
      }
      if (this.fieldtype === 'area') {
        params.code = this.lastCode
      } else if (this.fieldtype === 'ip') {
        params.ip = this.ip
      }
      let chain = await getInquiryGeo()
      chain
        .params(params)
        .onSuccess(res => {
          // console.log(res)
          if (this.$toType(res) !== 'object') res = {}

          this.data = res || {}
          let { timezone = {}, nowtime } = this.data
          this.lat = timezone.lat || ''
          this.lng = timezone.lng || ''
          this.timeZone = timezone.gmtOffset // 时区
          this.nowtime = nowtime || ''
          this.time = this.timeZone !== undefined ? this.$getLocalTime(this.timeZone, this.nowtime * 1000) : '-'
          this.countryCode = this.data.country_code || ''
          this.level = this.data.level || ''
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss">
.map-dialog {
  position: fiexed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  .ant-modal-body {
    padding-top: 0;
  }
}
</style>
<style lang="scss" scoped>
h3.title {
  line-height: 32px;
  padding: 16px 0;
  font-weight: bold;
  color: #333;
  border-bottom: solid 1px #ebebeb;
}
.info-box {
  padding: 18px 0 12px;
  p {
    float: left;
    width: 406px;
    height: 24px;
    line-height: 24px;
    margin-bottom: 16px;
    color: #666;
  }
  .week {
    margin-left: 12px;
  }
}
</style>
